import { ammRestRequest } from 'core/utils/backend-service';
import { MaterialDefinition } from 'modules/settings/pods/settings-materials/material-definition.vm';
import { MaterialDefinitionFormState } from 'modules/settings/pods/settings-materials/settings-material-definitions-form/settings-material-definitions-form.model';
import {
    MaterialDefinition as MaterialDefinitionApi,
    MaterialDefinitionsListApiResponse,
} from './material-definitions.api';
import {
    mapFormToPayload,
    mapMaterialDefinitionFromApiToVm,
    mapMaterialDefinitionsListFromApiToVm,
} from './material-definitions.mapper';

export interface SortParam {
    field: string;
    direction: 'asc' | 'desc';
}

export const getMaterialDefinitions = (
    page: number = 0,
    size: number = 200,
    sort?: SortParam
): Promise<MaterialDefinition[]> => {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (sort) {
        params.set('sort', `${sort.field},${sort.direction}`);
    }
    return ammRestRequest('GET', `api/v1/material_definitions?${params.toString()}`)
        .then((response) => response.json() as Promise<MaterialDefinitionsListApiResponse>)
        .then(mapMaterialDefinitionsListFromApiToVm);
};

export const getMaterialDefinitionById = (id: string): Promise<MaterialDefinition> =>
    ammRestRequest('GET', `api/v1/material_definitions/${id}`)
        .then((response) => response.json() as Promise<MaterialDefinitionApi>)
        .then(mapMaterialDefinitionFromApiToVm);

export const createMaterialDefinition = (formState: MaterialDefinitionFormState): Promise<Response> =>
    ammRestRequest('POST', 'api/v1/material_definitions', { body: mapFormToPayload(formState) });

export const updateMaterialDefinition = (id: string, formState: MaterialDefinitionFormState): Promise<Response> =>
    ammRestRequest('PUT', `api/v1/material_definitions/${id}`, { body: mapFormToPayload(formState) });

export const deleteMaterialDefinition = (id: string): Promise<Response> =>
    ammRestRequest('DELETE', `api/v1/material_definitions/${id}`);
